import React, { useRef, useState, useEffect } from 'react'
import './ResetPwPopup.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom/dist/umd/react-router-dom.development';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import emailjs from '@emailjs/browser';
import OTPModal from './OTPModal';


const ResetPwPopup = ({ isOpen, onClose }) => {
  const [UserName, setUserName] = useState(''); // State variable to store user email
  const [OTP, setOTP] = useState('');
  const [isDialogOpen2, setDialogOpen2] = useState(false);
  const navigate = useNavigate();

  const handleOpenDialog = () => {
    // onClose();
    setDialogOpen2(true);
  };

  const handleCloseDialog2 = () => {
    onClose();
    setDialogOpen2(false);
  };

  const handleOverlayClick = () => {
    // Redirect to login page when clicking outside the modal
    navigate('/sign-in');
  };

  const handleUserNameChange = (event) => {
    setUserName(event.target.value); // Update UserEmail state with the input value
  };

  const form = useRef();
  const handleResetPasswordInquiry = async (e) => {
    e.preventDefault();

    // Validate email field
    if (!UserName.trim()) {
      toast.error('Please enter your email address', {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }

    // Validate email format
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(UserName.trim())) {
      toast.error('Please enter a valid email address', {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }

    axios.post(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getEmailByUsername`, { username: UserName })
      .then(async (response) => {
        const email = response.data.email;

        if (email) {
          const otp = Math.floor(1000 + Math.random() * 9000);
          setOTP(otp);

          let dataSend = {
            email: email,
            otp: otp,
          };

          try {
            const res = await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/sendEmail`, {
              method: "POST",
              body: JSON.stringify(dataSend),
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            });

            if (res.status >= 200 && res.status < 300) {
              toast.success("OTP sent successfully!");
              // ✅ ONLY open modal if email is found and OTP request is successful
              handleOpenDialog();
            } else {
              toast.error("Failed to send OTP. Please try again.");
            }
          } catch (sendError) {
            console.error("Error sending OTP:", sendError);
            toast.error("An error occurred while sending the OTP.");
          }
        } else {
          toast.error('Username or Email not found', {
            position: 'top-center',
            autoClose: 3000,
          });
        }
      })
      .catch((error) => {
        console.error('Error fetching email:', error);
        const message = error.response?.status === 404 ? 'Username or Email not found' : 'An error occurred while fetching your details';
        toast.error(message, {
          position: 'top-center',
          autoClose: 3000,
        });
      });
  };
  return (
    <div className={`modal ${isOpen ? 'open' : ''}`}>
      <div className="modal-overlay" onClick={handleOverlayClick}></div>
      <div className="modal-content">
        {/* Close icon button */}
        <button className="close-icon" onClick={() => { navigate('/sign-in'); }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
        <h3>Reset Password</h3>
        <p style={{ width: "50%", textAlign: 'center' }}>Enter the email address associated with your account, and we'll email you the OTP to reset your password.</p>
        <input
          type="email"
          value={UserName}
          onChange={handleUserNameChange}
          className='inp'
          placeholder="Enter your Email"
          style={{ width: "90%", maxWidth: "340px", minWidth: "180px", textAlign: 'center', margin: '10px auto' }}
        />
        <button
          onClick={handleResetPasswordInquiry}

          className='ResetButton'
        >
          SEND OTP
        </button>
        {isDialogOpen2 && (
          <OTPModal isOpen2={isDialogOpen2} onClose2={handleCloseDialog2} SendedOtp={OTP} _username_={UserName}
          />
        )}
      </div>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{ zIndex: 9999 }}
      />
    </div>
  );
};
export default ResetPwPopup